import React, { useEffect, useState } from "react";
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from "reactstrap";
import parse from "html-react-parser";
import {
  getNotifications as onGetNotifications,
  changeStatusNotification as onChangeStatusNotification,
} from "../../slices/thunks";
//import images
import imageEmpty from "../../assets/images/new.png";
import bell from "../../assets/images/svg/bell.svg";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";

const NotificationDropdown = () => {
  const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
  const dispatch = useDispatch();
  const toggleNotificationDropdown = () => {
    setIsNotificationDropdown(!isNotificationDropdown);
    if (!isNotificationDropdown) {
      const unreadNot = notifications.filter((n) => n.not_status == 0);
      unreadNot.map((notification) => {
        const data = {
          not_id: notification.not_id,
          status: 1,
        };
        dispatch(onChangeStatusNotification(data));
      });
      // unreadNot.length > 0 && dispatch(onGetNotifications());
    }
  };

  //Tab
  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const selectNotificationData = createSelector(
    (state) => state.Notifications,
    (notifications) => notifications
  );
  // Inside your component
  const { notifications } = useSelector(selectNotificationData);

  useEffect(() => {
    dispatch(onGetNotifications());
    const interval = setInterval(() => {
      dispatch(onGetNotifications());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isNotificationDropdown}
        toggle={toggleNotificationDropdown}
        className="topbar-head-dropdown ms-1 header-item"
      >
        <DropdownToggle
          type="button"
          tag="button"
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none"
        >
          <i className="bx bx-bell fs-22"></i>
          {notifications &&
            notifications.filter((n) => n.not_status == 0).length > 0 && (
              <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
                {notifications.filter((n) => n.not_status == 0).length}
                <span className="visually-hidden">alerts</span>
              </span>
            )}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div className="dropdown-head bg-primary bg-pattern rounded-top">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0 fs-16 fw-semibold text-white">
                    {" "}
                    Notifications{" "}
                  </h6>
                </Col>
                {notifications && notifications.length > 0 && (
                  <div className="col-auto dropdown-tabs">
                    <span className="badge bg-light-subtle text-body fs-13">
                      {notifications.filter((n) => n.not_status === 0).length}
                    </span>
                  </div>
                )}
              </Row>
            </div>
          </div>

          <div className="w-25 w-sm-50 pt-3 mx-auto">
            <img src={bell} className="img-fluid" alt="user-pic" />
          </div>
          <div className="text-center pb-5 mt-2">
            {notifications && notifications.length > 0 ? (
              notifications.map((notification) => (
                <Col key={notification.not_date} className="notification-item">
                  <Row className="align-items-center">
                    <Col xs="2">
                      <img
                        src={
                          notification.not_productImageURL
                            ? notification.not_productImageURL
                            : imageEmpty
                        }
                        alt="Product"
                        className="img-fluid rounded"
                      />
                    </Col>
                    <Col xs="10">
                      <div className="text-muted">
                        <h6 className="mb-1">{parse(notification.not_text)}</h6>
                        <p className="mb-0">
                          <small>
                            {new Date(notification.not_date).toLocaleString()}
                          </small>
                        </p>
                        <a
                          href={notification.not_productURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary"
                        >
                          View Product
                        </a>
                      </div>
                    </Col>
                  </Row>
                </Col>
              ))
            ) : (
              <h6 className="fs-18 fw-semibold lh-base">
                You have no new notifications
              </h6>
            )}
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default NotificationDropdown;
